<i18n lang="yaml">
en:
  signIn: 'Log in'
  registration: 'Sign up'
ru:
  signIn: 'Войти'
  registration: 'Зарегистрироваться'
</i18n>

<template>
  <div class="container header__container header__container--bottom">
    <div class="header__main">
      <nuxt-link
        class="header__logo-link"
        :to="localePath('/')"
      >
        <white-logo class="header__white-logo"></white-logo>
        <color-logo class="header__color-logo"></color-logo>
      </nuxt-link>

      <header-menu
        v-show="isNavOpened"
        class="header__main-nav"
        :menu="menu"
        :is-nav-opened="isNavOpened"
        @close="closeNav"
      ></header-menu>

      <div class="header__control">
        <div class="header__control-panel">
          <a
            class="btn btn--xs btn--outline"
            href="https://my.selectel.ru/login"
            rel="noopener noreferrer"
            target="_blank"
          >
            <span v-html="$t('signIn')"></span>
          </a>

          <a
            class="btn btn--xs btn--dark"
            href="https://my.selectel.ru/registration"
            rel="noopener noreferrer"
            target="_blank"
          >
            <span v-html="$t('registration')"></span>
          </a>
        </div>

        <button
          v-if="isNavOpened === false"
          class="header__open-button"
          type="button"
          title="Открыть меню"
          @click="openNav"
        >
          <burger-icon></burger-icon>
        </button>

        <button
          v-else
          class="header__close-button"
          type="button"
          title="Закрыть меню"
          @click="closeNav"
        >
          <close-icon></close-icon>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import HeaderMenu from '~/components/menu/Menu'

  import WhiteLogo from '~/assets/icons/header/white-logo.svg'
  import ColorLogo from '~/assets/icons/header/color-logo.svg'
  import BurgerIcon from '~/assets/icons/header/burger.svg'
  import CloseIcon from '~/assets/icons/header/close.svg'

  export default {
    name: 'HeaderMain',
    components: {
      HeaderMenu,
      WhiteLogo,
      ColorLogo,
      BurgerIcon,
      CloseIcon
    },
    props: {
      menu: {
        type: Array,
        default: () => []
      },
      onToggle: {
        type: Function,
        default: () => {
        }
      }
    },
    data() {
      return {
        isNavOpened: false,
        scrollPosition: 0
      }
    },
    watch: {
      isNavOpened() {
        this.onToggle(this.isNavOpened)
      },
      scrollPosition(newValue) {
        return newValue
      }
    },
    mounted() {
      window.addEventListener('keydown', evt => {
        if (evt.key === 'Escape' || evt.key === 'Esc') this.closeNav()
      })

      window.addEventListener('resize', () => {
        if (this.isNavOpened && this.$nuxt.$breakpoints.lLg) this.closeNav()
      })

      window.addEventListener('scroll', () => {
        if (this.isNavOpened === false)
          this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop
      }, false)
    },
    beforeDestroy() {
      this.closeNav()
    },
    methods: {
      openNav() {
        this.isNavOpened = true

        const bodyElement = document.querySelector('body')
        bodyElement.style.paddingRight = `${window.innerWidth - document.documentElement.clientWidth}px`
        bodyElement.classList.add('locked')
      },
      closeNav() {
        this.isNavOpened = false

        const bodyElement = document.querySelector('body')
        bodyElement.classList.remove('locked')
        bodyElement.removeAttribute('style')
        window.scrollTo( 0, this.scrollPosition )
      }
    }
  }
</script>

<style lang="scss">
  body {
    &.locked {
      position: fixed;
      width: 100%;
      height: 100%;
      overflow: hidden;
    }
  }

  .header__container {
    &--bottom {
      @media (max-width: $breakpoint-lg) {
        height: 100%;
      }
    }
  }

  .header__main {
    display: grid;
    grid-template-columns: 2fr 7fr 3fr;
    grid-template-areas: 'selectel-logo main-nav header-control';
    grid-column-gap: 16px;
    justify-content: space-between;
    padding: 10px 0 0;

    @media (max-width: $breakpoint-xl) {
      grid-template-columns: 2fr 6.5fr 3.5fr;
    }

    @media (max-width: $breakpoint-lg) {
      grid-template-columns: auto;
      grid-template-areas: 'selectel-logo header-control' 'main-nav main-nav';
      padding: 8px 0;
    }
  }

  .header__logo-link {
    grid-area: selectel-logo;
    display: flex;
    align-items: flex-start;
    align-self: start;
    margin-bottom: 7px;

    @media (max-width: $breakpoint-lg) {
      margin-bottom: 0;
    }
  }

  .header__white-logo {
    display: none;
  }

  .header__main-nav {
    grid-area: main-nav;
  }

  .header__control {
    grid-area: header-control;
    display: grid;
    grid-auto-flow: column;
    grid-column-gap: 24px;
    justify-content: flex-end;
    align-items: center;
  }

  .header__control-panel {
    display: flex;
    align-items: center;
    color: $primary;

    @media (max-width: $breakpoint-lg) {
      display: none;
    }

    a:not(:last-child) {
      margin-right: 8px;
    }

    svg {
      width: 16px;
      max-height: 16px;
      margin-right: 8px;
    }
  }

  .header__open-button,
  .header__close-button {
    display: none;
    justify-content: center;
    align-items: center;
    border: none;
    outline: none;
    padding: 0;
    background-color: transparent;
    cursor: pointer;

    @media (max-width: $breakpoint-lg) {
      display: flex;
    }

    &:hover,
    &:focus {
      color: $secondary;
    }

    svg {
      flex-shrink: 0;
      width: 24px;
      height: 24px;
    }
  }
</style>